import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import LocalDayOfWeekLong from '../LocalDayOfWeekLong'
import Moment from 'moment'
import PropTypes from 'prop-types';
class AttivitaGiorniPrecedentiNonChiuse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _loading: false,
            error: null,
            items: []
        };
        this.oggi = Moment().format('YYYY-MM-DD');
        this.loadData = this.loadData.bind(this)
        this.renderOnClickGiorno = this.renderOnClickGiorno.bind(this)
    }

    componentDidMount() {
        this.loadData(this.props.giorno);
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.giorno !== this.props.giorno){
            this.loadData(nextProps.giorno)
        }
    }

    loadData(giorno) {

        if (giorno === undefined) return;

        this.setState({_loading: true});
        client.loadStatsPrevdays(this.props.idUtente,
            giorno, //Moment(giorno).add(1, 'days').format('YYYY-MM-DD'),
            this.props.numgg).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{

                    this.setState({
                        items: data.items,
                        attPerDay: data.attPerDay,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    renderOnClickGiorno(giorno){
        let giornoCnt = <LocalDayOfWeekLong data={giorno} />;
        if (giorno === this.oggi){
          giornoCnt = "Oggi";
        }
        if (this.props.onClickGiorno !== undefined){
            return <a href="#" onClick={(ev) => this.props.onClickGiorno(giorno)}>{giornoCnt}</a>
        }
        else
        {
            return {giornoCnt}
        }
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }
        let attivitaList = [];
        this.state.items.map((item, index, arr) => {
            if (item.attivitaDaCompletare) {
                attivitaList.push((<div key={item.giorno}
                                        className="ui red horizontal label">{this.renderOnClickGiorno(item.giorno)}</div>));
            }
        });

        let cnt = null;
        if (attivitaList.length > 0){
            cnt = (<div className="ui error message">

                <div className="ui center aligned">
                    <div className="ui labels">Negli ultimi {this.props.numgg} giorni ci sono delle attività non chiuse: {attivitaList}</div>
                </div>
            </div>)

        }

        return (<div>
            {cnt}
            {loader}
        </div>)
    }
}

AttivitaGiorniPrecedentiNonChiuse.PropTypes = {
    giorno: PropTypes.string.isRequired,
    numgg: PropTypes.number.isRequired,
    idUtente: PropTypes.number.isRequired,
    onClickGiorno: PropTypes.func,
}

AttivitaGiorniPrecedentiNonChiuse.defaultProps = {
    numgg: 0,
}
export default AttivitaGiorniPrecedentiNonChiuse;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaGiorniPrecedentiNonChiuse.js
 **/